






















































































import { computed, defineComponent, useContext } from '@nuxtjs/composition-api';
import TopSection from '~/components/pages/Top/TopSection.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { PRODUCT_PARAM_QUERIES, SMARTPHONE } from '~/constants';
import { TOP_SCENE_LIST_PC, TOP_SCENE_LIST_SP, TOP_KEYWORD_LIST_PC, TOP_KEYWORD_LIST_SP } from '~/constants/products';
import { url } from '~/utils';
import { sendGaEvent } from '~/utils/ga';
import { BooleanLike } from '~/enums';

export default defineComponent({
  components: {
    TopSection,
    AppLink,
  },
  setup() {
    const { app } = useContext();
    const isSmartPhone = app.$ua.deviceType() === SMARTPHONE;

    const sceneList = computed(() => {
      return isSmartPhone ? TOP_SCENE_LIST_SP : TOP_SCENE_LIST_PC;
    });
    const keywordList = computed(() => {
      return isSmartPhone ? TOP_KEYWORD_LIST_SP : TOP_KEYWORD_LIST_PC;
    });

    return {
      url,
      PRODUCT_PARAM_QUERIES,
      BooleanLike,
      sceneList,
      keywordList,
      sendGaEvent,
      isSmartPhone,
    };
  },
});
